$(function () {
  var BUNDLE_PAGE_SIZE = 20;
  var BUNDLE_SORT_VALUES = ["manual", "best-selling", "title-ascending", "title-descending", "price-ascending", "price-descending"];

  var currentSort = "manual";
  // activeFilters: applied storefront filter params, taken straight from collection.filters
  // (each entry { param, value } becomes a "filter.*=value" query param on the bundlecards fetch).
  var activeFilters = [];
  var cardsCache = {};

  // Styles for this section live in assets/section-bundle-collection.css: grid pagination
  // reveal, load-more button, drawer accordion, and the quick-view popup + Flickity slider.

  // Shared overlay, appended once; its .bundle-popup__body is populated from
  // the clicked item's hidden .bundle-item__popup on open.
  var $bundlePopup = $(".bundle-popup-overlay");
  if ($bundlePopup.length === 0) {
    $bundlePopup = $(
      '<div class="bundle-popup-overlay" aria-hidden="true">' +
        '<div class="bundle-popup" role="dialog" aria-modal="true">' +
          '<button type="button" class="bundle-popup__close" aria-label="Chiudi">' +
            '<svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg>' +
          '</button>' +
          '<div class="bundle-popup__body"></div>' +
        '</div>' +
      '</div>'
    );
    $("body").append($bundlePopup);
  }
  var bundleFlkty = null;
  var __bundleFlickityLoading = false;
  var __bundleFlickityQueue = [];
  var footerFlkty = null;
  var footerScrollX = 0; 

  // Inject the "Carica altro" button once, right after the product list.
  if ($(".bundle-collection .load-more_wrap").length === 0) {
    $('<div class="load-more_wrap" style="text-align:center;display:none;"><button type="button" class="bundle-collection__load-more">Carica altro</button></div>')
      .insertAfter($(".bundle-collection__main product-list").first());
  }

  function getActiveGrid() { return $(".bundle-collection__product-grid.active_gird").first(); }
  function getActiveHandle() { var $g = getActiveGrid(); return $g.length ? $g.attr("data-collection") : null; }

  function escapeHtml(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
  function escapeAttr(s) { return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;"); }

  // ---- bundlecards endpoint: collection.filters + filtered/sorted handles --
  function buildCardsUrl(handle, sort, filters) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    var qs = "?view=bundlecards&sort_by=" + encodeURIComponent(sort || "manual");
    for (var i = 0; i < filters.length; i++) {
      qs += "&" + encodeURIComponent(filters[i].param) + "=" + encodeURIComponent(filters[i].value);
    }
    return root + "collections/" + handle + qs;
  }

  function fetchCards(handle, sort, filters, cb) {
    var url = buildCardsUrl(handle, sort, filters);
    if (cardsCache[url]) { cb(cardsCache[url]); return; }
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var data = { handles: [], filters: [] };
        try { data = JSON.parse(text.trim()); } catch (e) {}
        cardsCache[url] = data;
        cb(data);
      })
      .catch(function () { cb({ handles: [], filters: [] }); });
  }

  // ---- Drawer built from collection.filters, using the theme's facet markup -
  // NOTE: intentionally NO <form> and NO name="filter.*" inputs, so the theme's
  // facet-filters JS (which binds to #facet-filters-form) never hijacks this and
  // there's no page reload. Our own change handler drives the AJAX instead.
  // Groups are collapsed by default and we drive open/close ourselves (see the
  // .js-bundle-facet-toggle handler) rather than via is="toggle-button", so the
  // accordion works cross-browser for this dynamically injected markup.
  function buildDrawer(filters) {
    var $content = $("#facet-filters .drawer__content");
    if ($content.length === 0) return;
    if (!filters || filters.length === 0) {
      $content.html('<div class="product-facet__filter-list"><p class="text--subdued">Nessun filtro disponibile.</p></div>');
      return;
    }
    var html = '<div class="product-facet__filter-list">';
    for (var f = 0; f < filters.length; f++) {
      var filter = filters[f];
      if (!filter.values || filter.values.length === 0) continue; // skips price_range (no list values)
      var groupId = "facet-filter-" + escapeAttr(filter.param_name).replace(/\./g, '-');
      // Open a group only when it has an active (checked) value, matching the
      // theme's is_filter_group_open behavior; otherwise start collapsed.
      var groupOpen = false;
      for (var a = 0; a < filter.values.length; a++) { if (filter.values[a].active) { groupOpen = true; break; } }
      let filterName = "";
      let filterLabelDowncase = escapeHtml(filter.label).toLowerCase();
      if (filterLabelDowncase == "colore") {
        filterName = "filter__color"
      } else if (filterLabelDowncase == "effetti") {
        filterName = "filter__effets"
      }
      html += `<div class="product-facet__filter-item ${filterName} ${escapeHtml(filter.label).toLowerCase().replace(/ /g, "-")}">`;
      html += '<button type="button" class="collapsible-toggle text--strong js-bundle-facet-toggle" aria-controls="' + groupId + '" aria-expanded="' + (groupOpen ? "true" : "false") + '">';
      html += escapeHtml(filter.label);
      html += '<svg class="icon icon--chevron" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.2"></path></svg>';
      html += '</button>';
      html += '<collapsible-content id="' + groupId + '" class="bundle-facet-panel"' + (groupOpen ? "" : " hidden") + '>';
      html += '<div class="collapsible__content">';
      for (var v = 0; v < filter.values.length; v++) {
        var val = filter.values[v];
        var inputId = escapeAttr(filter.param_name) + "-" + v;
        var checked = val.active ? ' checked="checked"' : "";
        var disabled = (val.count === 0 && !val.active) ? " disabled" : "";
        html += '<div class="checkbox-container">';
        html += '<input class="checkbox js-bundle-facet" type="checkbox" id="' + inputId + '" value="' + escapeAttr(val.value) + '" data-param-name="' + escapeAttr(val.param_name) + '"' + checked + disabled + '>';
        html += '<label for="' + inputId + '">';
        if (val.image) { html += '<span class="swtch_img"><img src="' + escapeAttr(val.image) + '" alt="' + escapeAttr(val.label) + '" class="filter_color_img"></span><span class="swtch_lbl">'; }
        html += escapeHtml(val.label);
        html += '</span></label>';
        html += '</div>';
      }
      html += '</div>';
      html += '</collapsible-content>';
      html += '</div>';
    }
    html += '</div>';
    $content.html(html);
  }

  function readFiltersFromUI() {
    activeFilters = [];
    $("#facet-filters .js-bundle-facet:checked").each(function () {
      activeFilters.push({ param: $(this).attr("data-param-name"), value: $(this).val() });
    });
  }

  function readFiltersFromUrl() {
    activeFilters = [];
    try {
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (k.indexOf("filter.") === 0) activeFilters.push({ param: k, value: v });
      });
    } catch (e) {}
  }

  function updateUrl() {
    try {
      var url = new URL(window.location.href);
      var del = [];
      url.searchParams.forEach(function (v, k) { if (k.indexOf("filter.") === 0) del.push(k); });
      for (var d = 0; d < del.length; d++) url.searchParams.delete(del[d]);
      // Only reflect sort in the URL when the user picked a non-default sort;
      // "manual" is the default, so we strip it (otherwise it reappears on every load).
      if (currentSort && currentSort !== "manual") url.searchParams.set("sort_by", currentSort);
      else url.searchParams.delete("sort_by");
      for (var i = 0; i < activeFilters.length; i++) url.searchParams.append(activeFilters[i].param, activeFilters[i].value);
      history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  // Remove sort + filter params (used when the collection tab changes).
  function clearUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("sort_by");
      var del = [];
      url.searchParams.forEach(function (v, k) { if (k.indexOf("filter.") === 0) del.push(k); });
      for (var d = 0; d < del.length; d++) url.searchParams.delete(del[d]);
      history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function updateFilterButtonCount() {
    $(".product-facet__active-count").text(activeFilters.length > 0 ? activeFilters.length : "");
  }

  // ---- Grid ordering + pagination -----------------------------------------
  // We reorder the grid VISUALLY with the CSS `order` property and never move the
  // <product-item> nodes in the DOM. Moving a card would disconnect/reconnect its
  // nested <flickity-carousel>: the theme's FlickityCarousel destroys its slider in
  // disconnectedCallback but only builds it in its constructor (no connectedCallback),
  // so a moved card loses its slider for good and its two slides collapse on top of
  // each other. Keeping the nodes in place lets each card's Flickity instance survive
  // page load, tab change, filter and sort. Pagination order is driven by data-rank.

  // Show the first `visible` matching items (data-match="1"), ordered by data-rank
  // (the filtered+sorted position from the bundlecards endpoint); update count + load-more.
  function renderLoadMore() {
    var $grid = getActiveGrid();
    var $wrap = $(".bundle-collection .load-more_wrap").first();
    if ($grid.length === 0) { $wrap.hide(); return; }
    var items = $grid.children().get();
    var visible = parseInt($grid.attr("data-visible"), 10);
    if (!visible || isNaN(visible)) { visible = BUNDLE_PAGE_SIZE; $grid.attr("data-visible", visible); }

    // Collect matches and order them by rank so pagination follows the sorted result
    // even though DOM order is untouched. Missing rank -> 0, so the pre-fetch
    // immediate paint keeps the server-rendered order (stable sort).
    var matched = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute("data-match") === "1") matched.push(items[i]);
      else items[i].classList.remove("bundle-item--show");
    }
    matched.sort(function (a, b) {
      return (parseInt(a.getAttribute("data-rank"), 10) || 0) - (parseInt(b.getAttribute("data-rank"), 10) || 0);
    });

    var total = matched.length;
    for (var m = 0; m < matched.length; m++) {
      if (m < visible) matched[m].classList.add("bundle-item--show");
      else matched[m].classList.remove("bundle-item--show");
    }

    if (visible < total) $wrap.show(); else $wrap.hide();
    $(".product-facet__meta-bar-item--count").text(total + " Prodotti");
  }

  // Mark grid items in the (filtered + sorted) result set and give each its rank;
  // visual order comes from CSS `order`, the DOM order stays put. Reset to page 1.
  function applyResult(handles) {
    var $grid = getActiveGrid();
    if ($grid.length === 0) { renderLoadMore(); return; }
    var rank = {};
    for (var i = 0; i < handles.length; i++) rank[handles[i]] = i;
    $grid.children().each(function () {
      var h = this.getAttribute("data-handle");
      if (rank[h] !== undefined) {
        this.setAttribute("data-match", "1");
        this.setAttribute("data-rank", rank[h]);
        this.style.order = rank[h];
      } else {
        this.removeAttribute("data-match");
        this.removeAttribute("data-rank");
        this.style.order = "";
      }
    });
    $grid.attr("data-visible", BUNDLE_PAGE_SIZE);
    renderLoadMore();
  }

  // Paint the first page immediately (server-rendered order) so there's no empty
  // flash before the fetch. Clears any stale rank/order left from a previous visit.
  function immediatePaint() {
    var $grid = getActiveGrid();
    if ($grid.length) {
      $grid.children().each(function () {
        this.setAttribute("data-match", "1");
        this.removeAttribute("data-rank");
        this.style.order = "";
      });
      $grid.attr("data-visible", BUNDLE_PAGE_SIZE);
      renderLoadMore();
    }
  }

  // Fetch bundlecards for the active collection, then apply. rebuildDrawer=true on tab change / init.
  function fetchAndApply(rebuildDrawer) {
    var handle = getActiveHandle();
    if (!handle) { renderLoadMore(); return; }
    fetchCards(handle, currentSort, activeFilters, function (data) {
      if (getActiveHandle() !== handle) return; // tab changed mid-flight; ignore stale response
      if (rebuildDrawer) {
        buildDrawer(data.filters);
        readFiltersFromUI(); // reconcile activeFilters with what actually exists in this collection
        updateFilterButtonCount();
        updateUrl();
      }
      applyResult(data.handles || []);
    });
  }

  // ---- Sort ----------------------------------------------------------------
  // Two sort-by controls can be on the page at once: one outside the filter
  // drawer and one inside it (.product-facet__meta-bar-item--sort_drawer). Both
  // carry the .js-sort-popover / .js-sort-toggle / .sort-by-selected-value hooks,
  // so every instance is driven from a single currentSort and kept in sync.

  // The markup reuses the same radio `name` in both controls, which would make
  // them one native group (only one radio checkable across both). Give each
  // control its own group so both can independently show their checked radio.
  (function dedupeSortGroups() {
    $(".js-sort-popover").each(function (i) {
      $(this).find('input[type="radio"]').attr("name", "bundle_sort_by_" + i);
    });
  })();

  function sortLabelFor(sortValue) {
    var $radio = $('.js-sort-popover input[type="radio"][value="' + sortValue + '"]').first();
    if ($radio.length === 0) $radio = $('.js-sort-popover input[type="radio"][value="manual"]').first();
    return $.trim($radio.attr("title") || $radio.closest(".popover__choice-item").find(".popover__choice-label").text() || "");
  }

  // Reflect sortValue in EVERY sort control: check its matching radio + update its label.
  function setSortUI(sortValue) {
    var $inputs = $('.js-sort-popover input[type="radio"]');
    if ($inputs.length === 0) return;
    $inputs.each(function () { this.checked = (this.value === sortValue); });
    $(".sort-by-selected-value").text(sortLabelFor(sortValue));
  }

  function closeSortPopovers() {
    $(".js-sort-popover").removeAttr("open").attr("aria-hidden", "true");
    $(".js-sort-toggle").attr("aria-expanded", "false");
  }

  // A radio changed in either control -> update sort, sync both controls, refetch.
  $("body").on("change", '.js-sort-popover input[type="radio"]', function () {
    currentSort = $(this).val();
    setSortUI(currentSort);
    updateUrl();
    fetchAndApply(false);
    closeSortPopovers();
  });

  // Toggle only the popover that belongs to the clicked button.
  $("body").on("click", ".js-sort-toggle", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    var $popover = $(this).closest(".popover-container").find(".js-sort-popover").first();
    var isOpen = $popover.attr("open") !== undefined;
    closeSortPopovers();
    if (!isOpen) {
      $popover.attr("open", "").attr("aria-hidden", "false");
      $(this).attr("aria-expanded", "true");
    }
  });

  // ---- Filters -------------------------------------------------------------
  $("body").on("change", "#facet-filters .js-bundle-facet", function () {
    readFiltersFromUI();
    updateFilterButtonCount();
    updateUrl();
    fetchAndApply(false);
  });

  // Collapsible filter groups in the drawer.
  $("body").on("click", ".js-bundle-facet-toggle", function () {
    var $btn = $(this);
    var id = $btn.attr("aria-controls");
    var $panel = $("#" + id);
    var open = $btn.attr("aria-expanded");
    if (open == "false") {
      $panel.removeAttr("hidden");
      $btn.attr("aria-expanded", "true");
    } else {
      $panel.attr("hidden", "");
      $btn.attr("aria-expanded", "false");
    }
  });

  // Clear all filters (from the empty-state button or a clear control).
  $("body").on("click", '[data-action="clear-filters"]', function (evt) {
    evt.preventDefault();
    activeFilters = [];
    $("#facet-filters .js-bundle-facet").prop("checked", false);
    updateFilterButtonCount();
    updateUrl();
    fetchAndApply(false);
  });

  // ---- Load more -----------------------------------------------------------
  $("body").on("click", ".bundle-collection__load-more", function () {
    var $grid = getActiveGrid();
    if ($grid.length === 0) return;
    var visible = parseInt($grid.attr("data-visible"), 10) || BUNDLE_PAGE_SIZE;
    $grid.attr("data-visible", visible + BUNDLE_PAGE_SIZE);
    renderLoadMore();
  });

  // ---- Quick-view popup ----------------------------------------------------
  function bundleSyncDots(idx) {
    var $dots = $bundlePopup.find(".bundle-popup__dot");
    $dots.removeClass("is-active");
    $dots.eq(idx).addClass("is-active");
  }

  // Step relative in the slider (dir = -1 prev, +1 next).
  function bundleStep(dir) {
    if (bundleFlkty) { if (dir < 0) bundleFlkty.previous(true); else bundleFlkty.next(true); return; }
    var track = $bundlePopup[0].querySelector(".bundle-popup__track");
    if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
  }

  // Jump to a specific slide index.
  function bundleGoTo(idx) {
    if (bundleFlkty) { bundleFlkty.select(idx); return; }
    var track = $bundlePopup[0].querySelector(".bundle-popup__track");
    var slides = $bundlePopup[0].querySelectorAll(".bundle-popup__slide");
    if (track && slides[idx]) track.scrollTo({ left: slides[idx].offsetLeft, behavior: "smooth" });
    bundleSyncDots(idx);
  }

  // Load flickity.min.js on demand (uses window.__doonailsFlickitySrc if set, else derives it
  // from this script's own /assets/ URL). If unavailable, the native scroll-snap fallback applies.
  function ensureFlickity(cb) {
    if (typeof Flickity !== "undefined") { cb(); return; }
    __bundleFlickityQueue.push(cb);
    if (__bundleFlickityLoading) return;
    var src = window.__doonailsFlickitySrc;
    if (!src) {
      var sc = document.querySelector('script[src*="section-bundle-collection.js"]');
      if (sc) src = sc.src.split("?")[0].replace("section-bundle-collection.js", "flickity.min.js");
    }
    if (!src) { return; }
    __bundleFlickityLoading = true;
    var s = document.createElement("script");
    s.src = src;
    s.onload = function () {
      __bundleFlickityLoading = false;
      var q = __bundleFlickityQueue.slice(); __bundleFlickityQueue = [];
      for (var i = 0; i < q.length; i++) { try { q[i](); } catch (e) {} }
    };
        s.onerror = function () {
      // Still flush the queue so callers fall back to the native scroll slider and the
      // popup opens instead of getting stuck waiting on a library that never loaded.
      __bundleFlickityLoading = false;
      var q = __bundleFlickityQueue.slice(); __bundleFlickityQueue = [];
      for (var i = 0; i < q.length; i++) { try { q[i](); } catch (e) {} }
    };
    document.head.appendChild(s);
  }

  var bundleOpenToken = 0; // bumps on every open/close so a slow prepare can't reveal a stale popup

  // Preload every popup image (via detached Image objects, which fetch even while the overlay
  // is still hidden) and resolve once they're all cached. A safety timeout guarantees the
  // popup still opens if an image stalls.
  function whenBundleImagesReady(imgs, cb, timeoutMs) {
    var srcs = [];
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].loading = "eager";
      var s = imgs[i].currentSrc || imgs[i].getAttribute("src");
      if (s) srcs.push(s);
    }
    if (srcs.length === 0) { cb(); return; }
    var settled = false;
    var finish = function () { if (settled) return; settled = true; cb(); };
    var remaining = srcs.length;
    var done = function () { if (--remaining <= 0) finish(); };
    for (var j = 0; j < srcs.length; j++) {
      var pre = new Image();
      pre.onload = done;
      pre.onerror = done;
      pre.src = srcs[j];
    }
    if (timeoutMs) setTimeout(finish, timeoutMs);
  }

  function showBundlePopup() {
    $bundlePopup.addClass("is-open").attr("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function initBundleFlickity() {
    var track = $bundlePopup[0].querySelector(".bundle-popup__track");
    if (!track) return;
    if (typeof Flickity === "undefined") { bundleSyncDots(0); return; } // native scroll fallback
    bundleFlkty = new Flickity(track, {
      draggable: true,
      wrapAround: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: "center",
      imagesLoaded: true,
      adaptiveHeight: true
    });
    bundleFlkty.on("select", function () { bundleSyncDots(bundleFlkty.selectedIndex); });
    bundleSyncDots(0);
  }

  function destroyBundleFlickity() {
    if (bundleFlkty) { try { bundleFlkty.destroy(); } catch (e) {} bundleFlkty = null; }
  }

  function openBundlePopup($item) {
    var $src = $item.find(".bundle-item__popup").first();
    if ($src.length === 0) return;
    var myToken = ++bundleOpenToken; // invalidate any in-flight prepare from a previous click
    destroyBundleFlickity();
    $bundlePopup.find(".bundle-popup__body").html($src.html());

    var popupEl = $bundlePopup[0];
    var track = popupEl.querySelector(".bundle-popup__track");
    var slideCount = popupEl.querySelectorAll(".bundle-popup__slide").length;
    $bundlePopup.find(".bundle-popup__nav").css("display", slideCount > 1 ? "flex" : "none"); // single image: hide arrows/dots

    if (slideCount <= 1) {
      // Single image: nothing to initialize, open right away.
      showBundlePopup();
      bundleSyncDots(0);
      return;
    }

    // Multi-image: do NOT open yet. Warm the Flickity library and preload the images while the
    // overlay is still hidden, then reveal + initialize in the SAME tick — so the popup never
    // appears with an empty, un-initialized slider (which used to flash for a few seconds while
    // the library and images loaded).
    var imgs = track ? Array.prototype.slice.call(track.querySelectorAll("img")) : [];

    ensureFlickity(function () {
      if (myToken !== bundleOpenToken) return; // superseded by a newer open, or closed
      whenBundleImagesReady(imgs, function () {
        if (myToken !== bundleOpenToken) return; // superseded while images were loading
        showBundlePopup();     // reveal (display:flex) ...
        initBundleFlickity();  // ... and initialize before the browser paints this frame

        // Native fallback: keep dots in sync on swipe if Flickity failed to load.
        if (track && !bundleFlkty) {
          track.addEventListener("scroll", function () {
            if (bundleFlkty) return;
            bundleSyncDots(Math.round(track.scrollLeft / track.clientWidth));
          });
        }
      }, 2000);
    });
  }

  function closeBundlePopup() {
    bundleOpenToken++; // cancel any in-flight prepare
    destroyBundleFlickity();
    $bundlePopup.removeClass("is-open").attr("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  $("body").on("click", ".bundle-item__popup-button", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    openBundlePopup($(this).closest("product-item"));
  });

  $bundlePopup.on("click", ".bundle-popup__close", function (evt) { evt.preventDefault(); closeBundlePopup(); });
  $bundlePopup.on("click", function (evt) { if (evt.target === this) closeBundlePopup(); }); // click on dark backdrop
  $bundlePopup.on("click", ".bundle-popup__arrow--prev", function () { bundleStep(-1); });
  $bundlePopup.on("click", ".bundle-popup__arrow--next", function () { bundleStep(1); });
  $bundlePopup.on("click", ".bundle-popup__dot", function () {
    var idx = parseInt($(this).attr("data-index"), 10);
    if (!isNaN(idx)) bundleGoTo(idx);
  });
  $(document).on("keydown", function (evt) {
    if (evt.key === "Escape" && $bundlePopup.hasClass("is-open")) closeBundlePopup();
  });

  // ---- Category / subcategory tabs -----------------------------------------
  $("body").on("click", ".bundle_category_btn", function () {
    if ($(this).is("[data-parent]")) {
      var parentCollection = $(this).attr("data-parent");
      $(".bundle-category__subcategory").attr("hidden", "");
      $('.bundle-category__subcategory[data-parent="' + parentCollection + '"]').removeAttr("hidden");
      $(".bundle-category__category").removeClass("is-active");
      $(this).addClass("is-active");
      setTimeout(function () {
        $('.bundle-category__subcategory[data-parent="' + parentCollection + '"] .bundle_category_btn:not(.is-active)').first().click();
      }, 10);
    }
    $(".bundle_category_subcategory_btn").removeClass("is-active");
    $(this).addClass("is-active");
    setTimeout(function () { applyTabCollectionFilter(); }, 20);
  });

  function applyTabCollectionFilter() {
    var activeTab = $(".bundle_category_subcategory_btn.is-active").attr("data-collection");
    if (!activeTab) { activeTab = $(".bundle-category__category.is-active").attr("data-collection"); }
    var found = false;

    $(".bundle-collection__product-grid").each(function () {
      if ($(this).attr("data-collection") == activeTab && $(this).children().length > 0) {
        $(this).addClass("active_gird");
        found = true;
      } else {
        $(this).removeClass("active_gird");
      }
    });

    if (!found) {
      $(".bundle-collection__main .empty-state").show();
      $(".product-facet__meta-bar").hide();
    } else {
      $(".bundle-collection__main .empty-state").hide();
      $(".product-facet__meta-bar").show();
    }

    // Collection changed: reset sort + filters, then rebuild drawer + grid for the new collection.
    currentSort = "manual";
    activeFilters = [];
    setSortUI("manual");
    clearUrl();
    immediatePaint();
    fetchAndApply(true);
  }

  // ---- Init ----------------------------------------------------------------
  readFiltersFromUrl();
  (function initSort() {
    var urlSort = null;
    try { urlSort = new URL(window.location.href).searchParams.get("sort_by"); } catch (e) {}
    currentSort = (urlSort && BUNDLE_SORT_VALUES.indexOf(urlSort) !== -1) ? urlSort : "manual";
    setSortUI(currentSort);
  })();
  immediatePaint();
  // Build the drawer from collection.filters and apply any URL filters/sort to the active grid.
  fetchAndApply(true);

  // Load the bundle cart engine (kept in its own asset to stay within deploy size limits).

  var bundleFilled = [];

  var BUNDLE_TIERS = {
    3: { icon: "percent", label: "20%" },
    5: { icon: "gift", label: "30%" },
    8: { icon: "gift", label: "50%" }
  };

  var BUNDLE_BASE_SLOTS = (function () {
    var n = $(".bundle-collection-footer__slot").length;
    return n > 0 ? n : 8;
  })();

  var BUNDLE_TIER_ICON_HTML = {};
  $(".bundle-collection-footer__slot--tier").each(function () {
    var pos = parseInt($(this).attr("data-slot"), 10);
    var tier = BUNDLE_TIERS[pos];
    if (tier) BUNDLE_TIER_ICON_HTML[tier.icon] = $(this).find(".bundle-collection-footer__slot-icon").html();
  });

function initFooterSlider() {
    var el = document.querySelector(".bundle-collection-footer__slots");
    if (!el || typeof Flickity === "undefined") return;

    // bundleRenderSlots() already destroyed any previous instance before
    // mutating the DOM, so we always create a fresh one here.
    if (footerFlkty) { try { footerFlkty.destroy(); } catch (e) {} footerFlkty = null; }

    footerFlkty = new Flickity(el, {
      cellSelector: ".bundle-collection-footer__slot",
      draggable: true,          // swipe/drag on mobile AND desktop
      freeScroll: true,         // natural momentum scrolling, not snap-to-cell
      contain: true,
      prevNextButtons: true,    // show prev/next arrows
      pageDots: false,
      cellAlign: "left",
      groupCells: false,
      wrapAround: false,
      imagesLoaded: true
    });
    if (el.querySelectorAll('.bundle-collection-footer__slot--filled.is-added').length > 6) {
      footerFlkty.select(footerFlkty.cells.length - 1);
    }

  }

  function bundlePopup() { return $(".bundle-popup-overlay"); }

  function bundleMoney(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return "€" + n.toFixed(2).replace(".", ",");
  }

  // 3-4 filled -> 20%, 5-7 -> 30%, 8+ -> 50%.
  function bundleDiscountRate(count) {
    if (count >= 8) return 0.5;
    if (count >= 5) return 0.3;
    if (count >= 3) return 0.2;
    return 0;
  }
  function bundleDiscountLabel(count) {
    var r = bundleDiscountRate(count);
    return r > 0 ? Math.round(r * 100) + "%" : "";
  }

  function bundleNoticeText(count) {
    switch (count) {
      case 0: return "Ancora 3 prodotti → Sconto del 20%.";
      case 1: return "Ancora 2 prodotti → Sconto del 20%.";
      case 2: return "Ancora 1 prodotti → Sconto del 20%.";
      case 3: return "Ancora 2 prodotti → 30% di sconto + omaggio.";
      case 4: return "Ancora 1 prodotti → 30% di sconto + omaggio.";
      case 5: return "Sbloccato! Ne mancano ancora 3 → Sconto del 50% + buono Doonails da 10 €!";
      case 6: return "Sbloccato! Ne mancano ancora 2 → Sconto del 50% + buono Doonails da 10 €!";
      case 7: return "Sbloccato! Ne mancano ancora 1 → Sconto del 50% + buono Doonails da 10 €!";
      default: return "Tutto incluso — 50% di sconto + buono Doonails da 10 €!";
    }
  }

  function bundleVariantQty(variantId) {
    var q = 0;
    for (var i = 0; i < bundleFilled.length; i++) {
      if (String(bundleFilled[i].variantId) === String(variantId)) q++;
    }
    return q;
  }

  function bundleReadEntry($el) {
    var $card = $('product-item.bundle-item[data-variant-id="' + $el.attr("data-variant-id") + '"]').first();
    var $img = "";
    if ($card.length) {
      $img = $card.attr("data-img");
    }
    return {
      variantId: $el.attr("data-variant-id"),
      productId: $el.attr("data-product-id"),
      image: $img,
      title: $el.attr("data-title") || "",
      priceCents: parseInt($el.attr("data-price"), 10) || 0
    };
  }

  function bundleRenderSlots() {
    if (footerFlkty) {
      try { footerFlkty.destroy(); } catch (e) {}
      footerFlkty = null;
    }

    var $wrap = $(".bundle-collection-footer__slots");
    if ($wrap.length === 0) return;
    var count = bundleFilled.length;
    var totalSlots = count >= BUNDLE_BASE_SLOTS ? count + 1 : BUNDLE_BASE_SLOTS;
    var $slots = $wrap.find(".bundle-collection-footer__slot");

    for (var s = $slots.length; s < totalSlots; s++) {
      $wrap.append(
        '<div class="bundle-collection-footer__slot" data-slot="' + (s + 1) + '">' +
          '<div class="bundle-collection-footer__slot-remove"><button type="button">x</button></div>' +
          '<div class="bundle-collection-footer__slot-plus"><span>+</span></div>' +
          '<div class="bundle-collection-footer__slot-image"></div>' +
        "</div>"
      );
    }
    $wrap.find(".bundle-collection-footer__slot").each(function () {
      var pos = parseInt($(this).attr("data-slot"), 10);
      if (pos > totalSlots && pos > BUNDLE_BASE_SLOTS) $(this).remove();
    });

    $wrap.find(".bundle-collection-footer__slot").each(function () {
      var $slot = $(this);
      var pos = parseInt($slot.attr("data-slot"), 10);
      var tier = BUNDLE_TIERS[pos];

      if ($slot.find(".bundle-collection-footer__slot-image").length === 0) {
        $slot.append('<div class="bundle-collection-footer__slot-image"></div>');
      }

      if (pos <= count) {
        var entry = bundleFilled[pos - 1];
        $slot
          .addClass("bundle-collection-footer__slot--filled is-added")
          .removeClass("bundle-collection-footer__slot--tier")
          .attr("data-price", entry.priceCents)
          .attr("data-variant-id", entry.variantId)
          .attr("data-product-id", entry.productId);
        $slot.find(".bundle-collection-footer__slot-icon, .bundle-collection-footer__slot-label").remove();
        if ($slot.find(".bundle-collection-footer__slot-remove").length === 0) {
          $slot.prepend('<div class="bundle-collection-footer__slot-remove"><button type="button">x</button></div>');
        }
        if ($slot.find(".bundle-collection-footer__slot-plus").length === 0) {
          $slot.append('<div class="bundle-collection-footer__slot-plus"><span>+</span></div>');
        }
        var alt = (entry.title || "").replace(/"/g, "&quot;");
        var imgHtml = entry.image
          ? '<img src="' + entry.image + '" alt="' + alt + '" loading="lazy" width="300" height="300">'
          : "";
        $slot.find(".bundle-collection-footer__slot-image").html(imgHtml);
      } else if (tier) {
        $slot
          .removeClass("bundle-collection-footer__slot--filled is-added")
          .addClass("bundle-collection-footer__slot--tier")
          .removeAttr("data-price")
          .removeAttr("data-variant-id")
          .removeAttr("data-product-id");
        $slot.find(".bundle-collection-footer__slot-image").empty();
        $slot.find(".bundle-collection-footer__slot-remove, .bundle-collection-footer__slot-plus").remove();
        if ($slot.find(".bundle-collection-footer__slot-icon").length === 0) {
          $slot.prepend('<span class="bundle-collection-footer__slot-icon">' + (BUNDLE_TIER_ICON_HTML[tier.icon] || "") + "</span>");
        }
        if ($slot.find(".bundle-collection-footer__slot-label").length === 0) {
          $slot.append('<span class="bundle-collection-footer__slot-label">' + tier.label + "</span>");
        }
      } else {
        $slot
          .removeClass("bundle-collection-footer__slot--filled is-added bundle-collection-footer__slot--tier")
          .removeAttr("data-price")
          .removeAttr("data-variant-id")
          .removeAttr("data-product-id");
        $slot.find(".bundle-collection-footer__slot-icon, .bundle-collection-footer__slot-label").remove();
        $slot.find(".bundle-collection-footer__slot-image").empty();
        if ($slot.find(".bundle-collection-footer__slot-remove").length === 0) {
          $slot.prepend('<div class="bundle-collection-footer__slot-remove"><button type="button">x</button></div>');
        }
        if ($slot.find(".bundle-collection-footer__slot-plus").length === 0) {
          $slot.append('<div class="bundle-collection-footer__slot-plus"><span>+</span></div>');
        }
      }
    });
  }

  function bundleRenderFooter(isRemove) {
    var count = bundleFilled.length;
    var rate = bundleDiscountRate(count);
    // console.log('rate', rate);
    $(".bundle-collection-footer__set-heading h4").text("Il tuo set · " + count + " Articolo");
    $(".bundle-collection-footer__notice-text p").text(bundleNoticeText(count));
    $(".bundle-collection-footer").toggleClass("is-active", count >= 5);

    var totalCents = 0, originalCents = 0;
    for (var i = 0; i < bundleFilled.length; i++) {
      originalCents += bundleFilled[i].priceCents; // raw data-price, no discount
      totalCents += Math.round(bundleFilled[i].priceCents * (1 - rate));
    }
    $(".bundle-collection-footer__price-amount p").text(bundleMoney(totalCents));
    $(".bundle-collection-footer__price-amount p").attr('data-discounted-price', totalCents);

    // Struck original (undiscounted) total, injected once right before the amount.
    var $price = $(".bundle-collection-footer__price");
    var $orig = $price.find(".bundle-collection-footer__price-original");
    if ($orig.length === 0) {
      $orig = $('<div class="bundle-collection-footer__price-original"><p></p></div>');
      $price.find(".bundle-collection-footer__price-amount").before($orig);
    }
    var savedCents = originalCents - totalCents;
    if (rate > 0) {
      $orig.find("p").text(bundleMoney(originalCents));
      $orig.css("visibility", "visible");
    } else {
      $orig.css("visibility", "hidden");
      $orig.find("p").text('');
    }

    // Price hint: countdown to first tier while under discount, else savings line.
    if (rate > 0) {
      $(".bundle-collection-footer__price-hint p").text("Risparmi  " + bundleMoney(savedCents) + " · " + Math.round(rate * 100) + "%");
    } else {
      $(".bundle-collection-footer__price-hint p").text("Aggiungi " + (3 - count) + " e risparmia");
    }
    var celebrated = false;
    var $btn = $(".bundle-collection-footer__button");
    if (count > 2) {
      $btn.prop("disabled", false).removeClass("bundle-collection-footer__button--disabled");
    } else {
      $btn.prop("disabled", true).addClass("bundle-collection-footer__button--disabled");
    }

     if ((count == 3 || count == 5 || count == 8) && !celebrated && !isRemove) {
      celebrated = true;
      celebrate();
      openGift(count);
    }
    if (count < 3) {
      celebrated = false;
    }
  }

  function bundleRenderCards() {
    var count = bundleFilled.length;
    var rate = bundleDiscountRate(count);
    var label = bundleDiscountLabel(count);

    $("product-item.bundle-item").each(function () {
      var $card = $(this);
      var variantId = $card.attr("data-variant-id");
      var qty = bundleVariantQty(variantId);
      var priceCents = parseInt($card.attr("data-price"), 10) || 0;

      bundleSetAddedState($card, qty);

      var $sale = $card.find(".bundle-item__sale-price span").first();
      var $reg = $card.find(".bundle-item__regular-price").first();
      var $regSpan = $reg.find("span").first();
      var $badge = $card.find(".bundle-item__price-badge").first();

      if (rate > 0) {
        var discounted = Math.round(priceCents * (1 - rate));
        $sale.text(bundleMoney(priceCents));
        $regSpan.text(bundleMoney(discounted));
        $reg.addClass("sale");
        $card.addClass("has-discount");
        $badge.find("span").text(label);
        $card.find(".bundle-item__sale-price").css("display", "block");
        $badge.css("display", "block");
      } else {
        $sale.text(bundleMoney(priceCents));
        $regSpan.text(bundleMoney(priceCents));
        $reg.removeClass("sale");
        $card.removeClass("has-discount");
        $badge.find("span").text("");
        $card.find(".bundle-item__sale-price").css("display", "");
        $badge.css("display", "");
      }
    });
  }

  function bundleSetAddedState($el, qty) {
    if (!$el || $el.length === 0) return;
    if (qty > 0) {
      $el.addClass("added");
      $el.find(".bundle-item__quantity-input").val(qty);
    } else {
      $el.removeClass("added");
      $el.find(".bundle-item__quantity-input").val(1);
    }
  }

  function bundleSyncOpenPopup() {
    var $info = bundlePopup().find(".bundle-popup__info");
    if ($info.length === 0) return;
    bundleSetAddedState($info, bundleVariantQty($info.attr("data-variant-id")));
  }

  function bundleRender(isRemove = false) {
    bundleRenderSlots();
    bundleRenderFooter(isRemove);
    bundleRenderCards();
    bundleSyncOpenPopup();
    initFooterSlider();
  }

  function bundleAddUnit($el) {
    if (!$el || $el.length === 0) return;
    bundleFilled.push(bundleReadEntry($el));
    bundleRender();
  }

  function bundleRemoveUnit(variantId) {
    for (var i = bundleFilled.length - 1; i >= 0; i--) {
      if (String(bundleFilled[i].variantId) === String(variantId)) {
        bundleFilled.splice(i, 1);
        break;
      }
    }
    const remove = true;
    bundleRender(remove);
  }

  // ---- Events -------------------------------------------------------------
  $("body").on("click", ".productADD, .productPopupADD", function () {
    bundleAddUnit($(this).closest("product-item.bundle-item, .bundle-popup__info"));
  });

  $("body").on("click", ".bundle-item__quantity-btn--increase", function () {
    bundleAddUnit($(this).closest("product-item.bundle-item, .bundle-popup__info"));
  });

  $("body").on("click", ".bundle-item__quantity-btn--decrease", function () {
    var $el = $(this).closest("product-item.bundle-item, .bundle-popup__info");
    bundleRemoveUnit($el.attr("data-variant-id"));
  });

  $("body").on("click", ".bundle-collection-footer__slot-remove", function () {
    var $slot = $(this).closest(".bundle-collection-footer__slot");
    var pos = parseInt($slot.attr("data-slot"), 10);
    if (!$slot.attr("data-variant-id")) return;
    if (pos >= 1 && pos <= bundleFilled.length) {
      bundleFilled.splice(pos - 1, 1);
      const remove = true;
      bundleRender(remove);
    }
  });

  // Popup opens by cloning the card's hidden markup, so it starts pristine.
  // After the main script opens it, reflect the current qty for its variant.
  $("body").on("click", ".bundle-item__popup-button", function () {
    setTimeout(bundleSyncOpenPopup, 0);
  });

  bundleRender();


  function celebrate() {
    var emojis = ['🎉', '🎊', '✨', '🎈', '🎁', '🍾', '💫', '🌟', '🎂', '🥳', '🧁', '🍰', '🎀', '💝', '🕯️', '🎵'];
    var layer = document.getElementById('emoji-layer');

    // make 50 pieces that shoot up from the footer
    for (var i = 0; i < 50; i++) {
      var span = document.createElement('span');
      span.className = 'emoji';
      span.textContent = emojis[Math.floor(Math.random() * emojis.length)];

      // start along the bottom edge (footer)
      span.style.left = Math.random() * 100 + 'vw';
      span.style.fontSize = 12 + 'px';

      // each piece flies to its own random spot:
      //   --x = sideways drift, --y = how high it goes (negative = up)
      //   --r = final rotation
      span.style.setProperty('--x', (Math.random() * 240 - 120) + 'px');
      span.style.setProperty('--y', -(40 + Math.random() * 60) + 'vh');
      span.style.setProperty('--r', (Math.random() * 240 - 120) + 'deg');

      // small random head-start so they don't all move as one
      span.style.animationDelay = Math.random() * 0.3 + 's';

      layer.appendChild(span);

      // remove the piece once it's done
      setTimeout(function (el) {
        return function () { el.remove(); };
      }(span), 2200);
    }
  }

    var modal = $('#giftModal');

    function openGift(threshold) {
      var giftTitle = $(`variant-metacolor input[data-threshold="${threshold}"]`).attr('data-title');
      var giftImg = $(`variant-metacolor input[data-threshold="${threshold}"]`).attr('data-img');
      var giftPrice = $(`variant-metacolor input[data-threshold="${threshold}"]`).attr('data-price-money');
      if (!giftTitle || !giftImg) return;
      $('#giftName').text(giftTitle);
      $('.zero_actual_price').html(giftPrice);
      // modal.querySelector('.mm-gi-note').textContent = gift.note;
      modal.find('.mm-gi-imgzone img').attr('src', giftImg);
      setTimeout(function () {
        modal.removeAttr('hidden');
        document.body.style.overflow = 'hidden';
      }, 20);
    }

    // close the popup
    function closeGift() {
      modal.attr('hidden', '');
      document.body.style.overflow = '';
    }

    // close on Escape key
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeGift();
    });

     $("body").on("click", ".closeModel", function () {
      closeGift();
    });


function processVariants(variants, delay) {
  return new Promise((resolve) => {
    let completedIterations = 0;

    $.each(variants, function (index, value) {
      setTimeout(() => {

        $(`product-item.bundle-item[data-variant-id='${value}']`).find('button.bundle-item__add.productADD').trigger("click");

        // Increment the counter and check if all iterations are complete
        completedIterations++;
        if (completedIterations === variants.length) {
          resolve(); // Resolve the promise once all iterations are done
        }
      }, delay);
    });
  });
}

const currentUrl = window.location.href;
const decodedUrl = decodeURIComponent(currentUrl);
const urlParams = new URLSearchParams(decodedUrl.split('?')[1]);
const freeVariants = urlParams.get('free_ids')?.split(',') || [];
const filteredFreeVariants = freeVariants.filter(Boolean);
const setId = urlParams.get('set_id');
const singleVariants = urlParams.get('single_colors')?.split(',') || [];
const filteredSingleVariants = singleVariants.filter(Boolean);

let singleVariantsArray = [];
let singleVariantsString = '';
filteredSingleVariants.forEach((item) => {
  let itemParts = item.split(':');
  if (singleVariantsString != '') {
    singleVariantsString = singleVariantsString + ',' + item;
  } else {
    singleVariantsString = item;
  }
  singleVariantsArray.push(itemParts[0]);
});

const url = new URL(currentUrl);
url.searchParams.delete('free_ids');
url.searchParams.delete('optional_ids');
url.searchParams.delete('single_colors');
url.searchParams.delete('set_id');
const newUrl = url.toString();
console.log('newUrl', newUrl);
window.history.replaceState(null, '', newUrl);

if (filteredFreeVariants && filteredFreeVariants.length > 0) {
  processVariants(filteredFreeVariants, 200)
  .then(() => {
    $('#AddToCartBundle').attr('set-id', setId);
    $('#AddToCartBundle').addClass('updateProduct');
  });
}


if (singleVariantsArray.length > 0) {
  console.log('singleVariantsArray', singleVariantsArray);
  processVariants(singleVariantsArray, 200)
  .then(() => {
    $('#AddToCartBundle').attr('color-array', singleVariantsString);
    $('#AddToCartBundle').addClass('updateSingleProducts');
    return true;
  });
}

  function formatExpandedItemsToJsonArray(items) {
    const jsonArray = items.map(item => ({
      id: `gid://shopify/ProductVariant/${item.id}`,
      quantity: 1,
      customKey: item.price
    }));
    return JSON.stringify(jsonArray);
  }

  function generateUID() {
      var firstPart = (Math.random() * 46656) | 0;
      var secondPart = (Math.random() * 46656) | 0;
      firstPart = ("000" + firstPart.toString(36)).slice(-3);
      secondPart = ("000" + secondPart.toString(36)).slice(-3);
      return firstPart + secondPart;
  }


  async function addRelated(variantIdArray, $that) {
      let set_id = generateUID();

      let reduced_obj = variantIdArray.reduce(function(obj, b) {
          obj[b] = ++obj[b] || 1;
          return obj;
      }, {});

      let indexedObj = {};

      for (let i = 0; i < variantIdArray.length; i++) {
          indexedObj[i] = variantIdArray[i];
      }

      var product_data = [];
  
      let child_variant_ids = "";
      let free_variant_ids = "";
    
      Object.keys(reduced_obj).forEach((key, index) => {
          if (index != 0) {
              if (!child_variant_ids.includes(key)) {
                  child_variant_ids += key + ":" + reduced_obj[key];
                  child_variant_ids += '__';
              }
          }
      });


  let mainItemID = 0;
  let expandedItems = [];
  window.atcPriceCompare = 0;
  window.atcPrice = 0;
  $('.bundle-collection-footer__slot.is-added').each(function() {
    window.atcPriceCompare += parseInt($(this).attr('data-price'));
    const priceVar = parseInt($(this).attr('data-price'), 10) / 100;
    const variantId = parseInt($(this).attr('data-variant-id'), 10);
    expandedItems.push({ id: variantId, price: priceVar });
    if (free_variant_ids === "") {
      free_variant_ids = `${variantId}`;
    } else {
      free_variant_ids += `,${variantId}`;
    }
  });

  const expandJSON = formatExpandedItemsToJsonArray(expandedItems);
  console.log(expandJSON);

    
      const totalProducts = $('.bundle-collection-footer__slot.is-added').length;
      if (totalProducts == 5 || totalProducts == 6 || totalProducts == 7) {
        child_variant_ids += parseInt($(`variant-metacolor input[data-threshold="5"]`).val()) + ":" + 1;
        child_variant_ids += '__';
      } else if (totalProducts >= 8) {
        child_variant_ids += parseInt($(`variant-metacolor input[data-threshold="5"]`).val()) + ":" + 1;
        child_variant_ids += '__';
        child_variant_ids += parseInt($(`variant-metacolor input[data-threshold="8"]`).val()) + ":" + 1;
        child_variant_ids += '__';
      }

      let mixMatchVariant = "";
      if (totalProducts == 3 || totalProducts == 4) {
        mixMatchVariant = $(`variant-metacolor input[data-free-colors="3"]`).attr("data-title");
      } else if (totalProducts == 5 || totalProducts == 6 || totalProducts == 7) {
        mixMatchVariant = $(`variant-metacolor input[data-free-colors="5"]`).attr("data-title");
      } else if (totalProducts >= 8) {
        mixMatchVariant = $(`variant-metacolor input[data-free-colors="8"]`).attr("data-title");
      }

      window.atcPrice = parseInt($('.bundle-collection-footer__price-amount p').attr('data-discounted-price'));

        for (let key in indexedObj) {
          if (indexedObj.hasOwnProperty(key)) {
              if (key == 0) {
                  let props = {};
                  props['_refill-bundle-parent'] = true;
                  props['_refill-bundle'] = true;
                  props['_bundle-parent'] = true;
                  props['_bundle-mix_match'] = mixMatchVariant;
                if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
                  props['_refill-price'] = window.atcPrice;
                  props['_set'] = set_id;
                  props['_childItemsJson'] = expandJSON;
                  props['_free_variants'] = free_variant_ids;
                  props['_variants_set'] = child_variant_ids;
                  let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
                  product_data.push(prod);
                  mainItemID = parseInt(indexedObj[key]);
              }
          }
      }

      let freeGiftId = 0;
      let freeGiftPrice = 0;
      if (totalProducts == 5 || totalProducts == 6 || totalProducts == 7) {
        freeGiftId = parseInt($(`variant-metacolor input[data-threshold="5"]`).val());
        freeGiftPrice = parseInt($(`variant-metacolor input[data-threshold="5"]`).attr('data-price'));
        let upsell_prod_opt = { quantity: 1, id: freeGiftId };
          upsell_prod_opt["properties"] = {
              '_bundled-product': true,
              '_bundled-free': true,
              '_bundle-mix_match': true,
              '_discountAmount': freeGiftPrice,
              '_set_id': set_id
          };
          product_data.push(upsell_prod_opt);
      } else if (totalProducts >= 8) {
        freeGiftId = parseInt($(`variant-metacolor input[data-threshold="5"]`).val());
        freeGiftPrice = parseInt($(`variant-metacolor input[data-threshold="5"]`).attr('data-price'));
        let upsell_prod_opt = { quantity: 1, id: freeGiftId };
          upsell_prod_opt["properties"] = {
              '_bundled-product': true,
              '_bundled-free': true,
              '_bundle-mix_match': true,
              '_discountAmount': freeGiftPrice,
              '_set_id': set_id
          };
          product_data.push(upsell_prod_opt);

          freeGiftId = parseInt($(`variant-metacolor input[data-threshold="8"]`).val());
          freeGiftPrice = parseInt($(`variant-metacolor input[data-threshold="8"]`).attr('data-price'));
          let upsell_prod_opt_two = { quantity: 1, id: freeGiftId };
            upsell_prod_opt_two["properties"] = {
                '_bundled-product': true,
                '_bundled-free': true,
                '_bundle-mix_match': true,
                '_discountAmount': freeGiftPrice,
                '_set_id': set_id
            };
            product_data.push(upsell_prod_opt_two);
      }

      console.log(product_data);

      async function addItemsToCartAndProceed() {
          try {
              if ($('cart-drawer#mini-cart').find('line-item.line-item').hasClass('mix-match-birthday-set')) {
                const clearResponse = await fetch(`/cart/clear.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                    }
                });
        
                if (!clearResponse.ok) {
                    throw new Error("Error clearing the cart");
                }
              }

              const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                  body: JSON.stringify({ items: product_data }),
                  credentials: 'same-origin',
                  headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest'
                  },
                  method: 'POST'
              });

              const responseJson = await response.json();

              if (!response.ok) {
                  throw new Error(responseJson["description"] || "Error adding items to cart");
              }

              // After all items are added, proceed to the next step

                  fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                      const html = document.createElement("div");
                      html.innerHTML = data;
                      const newbox = html.querySelector("#mini-cart").innerHTML;
                      document.querySelector('#mini-cart').innerHTML = newbox;
                  })

                  fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                      const cartContent = await response2.json();
                    if(!window.upsellPopupActive){
                      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                          bubbles: true,
                          detail: {
                              cart: cartContent
                          }
                      }));

                      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                          bubbles: true,
                          detail: {
                              cart: cartContent,
                              openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                          }
                      }));
                    }else{
                      window.upsellPopupFunc(cartContent, $that);
                    }

                  });
                const cartUpdateEvent = new Event('cartUpdate');
                $('#AddToCartBundle').addClass('mix_match_found_cart')
                $('.bundle-collection-footer__button-icon').show();
                $('.bundle-collection-footer__button-text').show();
                $('.loader-button__loader').hide();


              $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                      status: "success",
                      error: ""
                  }
              }));
          } catch (error) {
              $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                      status: "error",
                      error: error.message
                  }
              }));
          }
      }

      // Call the function to add items to the cart and proceed
      addItemsToCartAndProceed();
  }




  $("body").on("click", "#AddToCartBundle:not(.bundle-collection-footer__button--disabled)", async function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).find('.bundle-collection-footer__button-icon').hide();
    $(this).find('.bundle-collection-footer__button-text').hide();
    $(this).find('.loader-button__loader').show();

    const $that = this;

    if ($(this).hasClass('updateProduct')) {
        const pre_set_id = $(this).attr('set-id'); // Get the pre_set_id
        let keysToRemove = []; // Array to store keys of items to be removed

        // Get the cart data
        await $.getJSON(`${window.themeVariables.routes.cartUrl}.js`, function (cart) {
            const items = cart.items;

            // Iterate through each cart item
            items.forEach((item) => {
                // Check for the _set_id or _set property
                if ((item.properties && item.properties._set_id === pre_set_id) ||
                    (item.properties && item.properties._set === pre_set_id)) {
                    keysToRemove.push(item.key); // Store the item's key
                }
            });
        });

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await $.ajax({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    } else if ($(this).hasClass('updateSingleProducts')) {
  
        const pre_set_id = $(this).attr('color-array');
        let keysToRemove = pre_set_id?.split(',') || [];
      
        $(this).attr('color-array', '');
        $(this).removeClass('updateSingleProducts')

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await $.ajax({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    }


      // Collect other items
      let items = [];
      let itemsOptionalIndex = [];

      const totalProducts = $('.bundle-collection-footer__slot.is-added').length;
      if (totalProducts == 3 || totalProducts == 4) {
        items.push(parseInt($(`variant-metacolor input[data-free-colors="3"]`).val()));
      } else if (totalProducts == 5 || totalProducts == 6 || totalProducts == 7) {
        items.push(parseInt($(`variant-metacolor input[data-free-colors="5"]`).val()));
      } else if (totalProducts >= 8) {
        items.push(parseInt($(`variant-metacolor input[data-free-colors="8"]`).val()));
      }

          $('.bundle-collection-footer__slot.is-added').each(function(index) {
              items.push(parseInt($(this).attr('data-variant-id')));
          });


    addRelated(items, $that);
    
    console.log(items);


  });


  

setTimeout(() => {
  $('.bundle-collection__main').find('product-item').each(function(){
    let reviewCount = $(this).find('.jdgm-prev-badge').attr('data-average-rating');
    let reviewCountInt = parseFloat(reviewCount)
    if (reviewCount && reviewCountInt > 4) {
      $(this).find('.item__reviews_widget_mobile').text(`${String(reviewCount).replace(/\.00/g, "")} ★`);
    }
  })
}, 1000);


document.addEventListener('click', function (event) {
  if (!event.target.closest('.popover-container') || event.target.closest('.popover__close-button') || event.target.closest('.popover__overlay')) {
    $('.js-sort-popover').removeAttr('open').attr("aria-hidden", "true");
    $('.js-sort-toggle').attr("aria-expanded", "false");
  }
});

});


(function () {
  const footer = document.querySelector('.bundle-collection-footer');
  if (!footer) return;

  const threshold = 100; // px scrolled before footer appears

  const onScroll = () => {
    if (window.scrollY > threshold) {
      footer.classList.add('is-visible');
    } else {
      footer.classList.remove('is-visible');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // check initial state
})();



(function () {
  function applyView(mediaList, view) {
    if (!mediaList) return;
    var pageDots = mediaList.querySelector('.flickity-page-dots');
    if (!pageDots) return;
    var dot = view === 'second' ? pageDots.lastElementChild : pageDots.firstElementChild;
    if (dot) dot.click();
  }

  function currentView() {
    return document.body.classList.contains('show-second-image-active') ? 'second' : 'first';
  }

  function setActive(view) {
    var firstBtn = document.getElementById('show_first_img_item');
    var secondBtn = document.getElementById('show_second_img_item');
    if (!firstBtn || !secondBtn) return;
    firstBtn.classList.toggle('active', view === 'first');
    secondBtn.classList.toggle('active', view === 'second');
    document.body.classList.toggle('show-second-image-active', view === 'second');
  }

  function applyToAll(view) {
    document.querySelectorAll('.bundle-item .product__media-list').forEach(function (mediaList) {
      applyView(mediaList, view);
    });
  }

  function bind() {
    var firstBtn = document.getElementById('show_first_img_item');
    var secondBtn = document.getElementById('show_second_img_item');
    if (!firstBtn || !secondBtn) return;

    firstBtn.addEventListener('click', function () {
      setActive('first');
      applyToAll('first');
    });

    secondBtn.addEventListener('click', function () {
      setActive('second');
      applyToAll('second');
    });

    // Cards below the fold init Flickity lazily on scroll — whenever one
    // becomes ready, apply whichever view is currently active.
    document.addEventListener('flickity:ready', function (event) {
      if (event.target && event.target.matches && event.target.matches('.bundle-item .product__media-list')) {
        applyView(event.target, currentView());
      }
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind)
    : bind();
})();



/* ================= EXIT-INTENT RECOVERY POPUP (mix-and-match only) =========
   Recovers users about to leave the bundle builder with >=1 slot filled.
   - Scoped by the presence of the bundle builder itself (this template only),
     so it is locale-safe (no hardcoded /mix-and-match URL) and never runs
     elsewhere.
   - Fires at most once per browser session (sessionStorage).
   - Only fires when >=1 slot is filled (.bundle-collection-footer__slot--filled).
   - Triggers: desktop pointer leaving via the TOP edge; mobile rapid upward
     swipe at the top of the page; and the Back button (history sentinel) on both.
   Note: a real tab-close can't render a custom popup (the page is unloading) —
   the top-edge move is the desktop proxy for "heading to the close/tab/address bar".
============================================================================ */
(function initMmExitIntent() {
  var footer = document.querySelector('.bundle-collection-footer');
  var modal = document.getElementById('mmExitModal');
  if (!footer || !modal) return; // not the mix-and-match page

  var SESSION_KEY = 'doonails_mm_exit_shown';
  var trapArmed = false;

  // Exact copy per number of filled slots (1..8; anything above 8 clamps to 8).
  var CONTENT = {
    1: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Solo 2 prodotti con uno sconto fino al 20%.',        count: 2, pct: '20% Sconto' },
    2: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Manca solo 1 prodotto per ottenere uno sconto del 20%.',        count: 2, pct: '20% Sconto' },
    3: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Solo 2 prodotti con uno sconto fino al 30% + omaggio.',       count: 3, pct: '30% Sconto' },
    4: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Solo 1 prodotto rimasto con uno sconto fino al 30% + omaggio.',       count: 3, pct: '30% Sconto' },
    5: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Ancora solo 3 prodotti con uno sconto fino al 50% + un buono Doonails da 10 €!',       count: 5, pct: '50% Sconto' },
    6: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Ancora solo 2 prodotti con uno sconto fino al 50% + un buono Doonails da 10 €!',       count: 5, pct: '50% Sconto' },
    7: { eyebrow: 'Aspetta un attimo',         head: 'Ci siamo quasi!',       text: 'Solo 1 prodotto rimasto con uno sconto fino al 50% + un buono Doonails da 10 €!',       count: 5, pct: '50% Sconto' },
    8: { eyebrow: 'Risparmio massimo', head: 'Tutto sbloccato!', text: 'Sconto del 50% + buono Doonails da 10 € assicurato.', maxed: true }
  };

  function filledCount() {
    return document.querySelectorAll('.bundle-collection-footer__slot--filled').length;
  }
  function shownThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }
  function isOpen() { return !modal.hidden; }
  function otherModalOpen() {
    var gift = document.getElementById('giftModal');
    return !!document.querySelector('.bundle-popup-overlay.is-open') ||
           !!(gift && !gift.hasAttribute('hidden'));
  }
  function canShow() {
    return !shownThisSession() && !isOpen() && !otherModalOpen() && filledCount() >= 1;
  }

  function render(n) {
    var c = CONTENT[Math.min(n, 8)];
    if (!c) return;
    modal.querySelector('.mm-ex-eyebrow').textContent = c.eyebrow;
    modal.querySelector('.mm-ex-head').textContent = c.head;
    modal.querySelector('.mm-ex-text').textContent = c.text;
    var prog = modal.querySelector('.mm-ex-prog');
    if (c.maxed) {
      prog.setAttribute('hidden', '');
    } else {
      prog.removeAttribute('hidden');
      modal.querySelector('.mm-ex-prog-count').textContent = c.count + ' di 8';
      modal.querySelector('.mm-ex-prog-pct').textContent = c.pct;
      modal.querySelector('.mm-ex-prog-fill').style.width = (c.count / 8 * 100) + '%';
    }
  }

  function open() {
    if (!canShow()) return;
    render(filledCount());
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    markShown(); // once per session — counted from the moment it is shown
  }
  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  // ---- Buttons + backdrop ----
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-mm-ex-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-mm-ex-complete]')) {
      e.preventDefault();
      close();
      footer.classList.add('is-visible'); // reveal the sticky set bar so they can finish
    }
  });
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // ---- Desktop: pointer leaves through the TOP of the viewport ----
  document.addEventListener('mouseout', function (e) {
    if (e.clientY <= 0 && !e.relatedTarget) open();
  });

  // ---- Mobile: rapid upward swipe while already at the top of the page ----
  var tsY = 0, tsT = 0;
  document.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches.length) return;
    tsY = e.touches[0].clientY;
    tsT = Date.now();
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    var dy = tsY - t.clientY;                               // > 0 = swiped up
    var dt = Date.now() - tsT;
    var atTop = (window.scrollY || window.pageYOffset || 0) <= 5;
    if (atTop && dy > 120 && dt > 0 && dt < 300) open();    // fast + long + upward
  }, { passive: true });

  // ---- Back button (desktop + mobile) ----
  // Arm a history sentinel once there is something to lose, so the first Back
  // press shows the popup instead of leaving. pushState only (the section's
  // sort/filter code uses replaceState, so there is no history conflict).
  function armTrap() {
    if (trapArmed || shownThisSession() || filledCount() < 1) return;
    try { history.pushState({ mmExit: true }, ''); trapArmed = true; } catch (e) {}
  }
  window.addEventListener('popstate', function () {
    if (canShow()) open();
  });

  // Arm as soon as the first slot fills; re-check whenever the slots mutate.
  var slots = footer.querySelector('.bundle-collection-footer__slots');
  if (slots && window.MutationObserver) {
    new MutationObserver(armTrap).observe(slots, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
  }
  armTrap(); // in case slots are already filled on load
})();